import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import BaseAppService from '../platform/scp/base/base-app-service';
import { ITableResponse } from '../../model/scp/purchase/response/tables-response';
import ApplicationAppService from '../platform/application-app-service';

interface BaseDataState {
    instrumentSummons: ITableResponse[];
    modality: ITableResponse[];
    disputeMode: ITableResponse[];
    purchaseItemSituation: ITableResponse[];
    typeContract: ITableResponse[];
    categoryProcess: ITableResponse[];
    loaded: boolean;
}

const initialState: BaseDataState = {
    instrumentSummons: [],
    modality: [],
    disputeMode: [],
    purchaseItemSituation: [],
    typeContract: [],
    categoryProcess: [],
    loaded: false,
};

const BaseDataContext = createContext<BaseDataState>(initialState);

export const BaseDataProvider = ({ children }: { children: ReactNode }) => {
    const [state, setState] = useState<BaseDataState>(initialState);

    useEffect(() => {
        const authData = ApplicationAppService.getAuthenticationData();
        if (authData) {
            loadBaseData();
        }
    }, []);

    async function loadBaseData() {
        try {
            const [instrumentSummons, modality, disputeMode, purchaseItemSituation, typeContract, categoryProcess] = await Promise.all([
                BaseAppService.listInstrumentSummons(),
                BaseAppService.listModality(),
                BaseAppService.listDisputeMode(),
                BaseAppService.listPurchaseItemSituation(),
                BaseAppService.listTypeContract(),
                BaseAppService.listCategoryProcess(),
            ]);
            setState({ instrumentSummons, modality, disputeMode, purchaseItemSituation, typeContract, categoryProcess, loaded: true });
        } catch {
            // se falhar, os componentes farão suas próprias chamadas normalmente
        }
    }

    return (
        <BaseDataContext.Provider value={state}>
            {children}
        </BaseDataContext.Provider>
    );
};

export const useBaseData = () => useContext(BaseDataContext);
